(function () {
  'use strict';

  var BLOCK_SELECTOR = '[data-divetia-stone-copy]';
  var JSON_SELECTOR = '[data-divetia-stone-copy-json]';
  var DESCRIPTION_SELECTOR = '[data-divetia-variant-description]';
  var FORM_SELECTOR = 'form[data-product-id]';
  var ID_INPUT_SELECTOR = '[name="id"]';
  var STICKY_FORM_SELECTOR = '#sticky-atc-form, .prod__sticky-atc form[data-product-id]';
  var STICKY_VARIANT_SELECTOR = '.combined-variant';
  var busSubscriptions = {};
  var observerStarted = false;
  var scheduledRender = {};
  var pendingOptionValues = {};
  var syncingSticky = false;

  function toStringId(value) { return value === null || value === undefined ? '' : String(value); }
  function normalizeOptionText(value) { return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function titleBase(block) {
    var fromBlock = block && block.getAttribute('data-title-base');
    if (fromBlock) return fromBlock;
    var title = document.querySelector('[data-divetia-variant-title]');
    var raw = title && (title.getAttribute('data-product-title') || title.textContent) || '';
    return raw.replace(/\s+[—-]\s+Lab-Grown\s+(Sapphire|Pink Diamond|White Diamond)\s*$/i, '').trim();
  }

  function fallbackCopy(option) {
    var normalized = String(option || '').toLowerCase();
    if (normalized.indexOf('pink') !== -1) {
      return { heading: 'Lab-Grown Pink Diamond', badge: 'Statement blush', copy: 'Lab-grown pink diamond gives this charm a warmer, more romantic glow while keeping the meaning of the design front and center.' };
    }
    if (normalized.indexOf('white') !== -1 || normalized.indexOf('clear') !== -1) {
      return { heading: 'Lab-Grown White Diamond', badge: 'Bright classic', copy: 'Lab-grown white diamond keeps the piece bright, clean, and timeless while the symbol stays front and center.' };
    }
    if (normalized.indexOf('sapphire') !== -1 || normalized.indexOf('blue') !== -1) {
      return { heading: 'Lab-Grown Sapphire', badge: 'Signature blue', copy: 'Lab-grown sapphire gives this charm its deep blue finish: classic, symbolic, and made for everyday wear.' };
    }
    return { heading: option || 'Selected Stone', badge: '', copy: '' };
  }

  function normalizeEntry(entry) {
    if (!entry) return null;
    var option = entry.option1 || entry.label || entry.title || '';
    var fallback = fallbackCopy(option);
    return {
      id: toStringId(entry.id),
      option1: option,
      heading: entry.heading || entry.label || fallback.heading || option,
      copy: entry.copy || entry.story || fallback.copy || '',
      badge: entry.badge || fallback.badge || '',
      descriptionHtml: entry.descriptionHtml || ''
    };
  }

  function parseJson(script) {
    if (!script) return {};
    try { return JSON.parse(script.textContent || '{}') || {}; } catch (error) { return {}; }
  }

  function findMap(block) {
    var productId = block.getAttribute('data-product-id');
    var scoped = productId ? document.querySelector(JSON_SELECTOR + '[data-product-id="' + productId + '"]') : null;
    var nearby = block.parentElement ? block.parentElement.querySelector(JSON_SELECTOR) : null;
    return parseJson(scoped || nearby || document.querySelector(JSON_SELECTOR));
  }

  function findForm(block) {
    var productId = block.getAttribute('data-product-id');
    var scoped = productId ? mainForms(productId)[0] : null;
    return scoped || block.closest(FORM_SELECTOR) || mainForms()[0] || document.querySelector(FORM_SELECTOR);
  }

  function productRecord(productId) {
    return window._themeProducts && productId ? window._themeProducts[productId] : null;
  }

  function productVariants(productId) {
    var record = productRecord(productId);
    return record && Array.isArray(record.variants) ? record.variants : [];
  }

  function variantById(productId, id) {
    var target = toStringId(id);
    return productVariants(productId).filter(function (variant) { return toStringId(variant.id) === target; })[0] || null;
  }

  function variantByOptions(productId, values) {
    var normalized = (values || []).map(normalizeOptionText).filter(Boolean);
    if (!normalized.length) return null;
    return productVariants(productId).filter(function (variant) {
      var options = (variant.options || [variant.option1, variant.option2, variant.option3]).map(normalizeOptionText).filter(Boolean);
      return normalized.every(function (value) { return options.indexOf(value) !== -1; });
    })[0] || null;
  }

  function mainForms(productId) {
    var selector = productId ? FORM_SELECTOR + '[data-product-id="' + productId + '"]' : FORM_SELECTOR;
    return Array.prototype.slice.call(document.querySelectorAll(selector)).filter(function (form) {
      return !form.matches(STICKY_FORM_SELECTOR) && !form.closest('.prod__sticky-atc');
    });
  }

  function stickyForms(productId) {
    return Array.prototype.slice.call(document.querySelectorAll(STICKY_FORM_SELECTOR)).filter(function (form) {
      return !productId || form.getAttribute('data-product-id') === productId;
    });
  }

  function setFormVariantId(form, variant) {
    var input = form && form.querySelector(ID_INPUT_SELECTOR);
    if (input && variant && variant.id) input.value = variant.id;
  }

  function optionValuesFromVariant(variant) {
    return variant && (variant.options || [variant.option1, variant.option2, variant.option3]).filter(Boolean) || [];
  }

  function clickMainOption(form, position, value) {
    var normalized = normalizeOptionText(value);
    var option = Array.prototype.slice.call(form.querySelectorAll('.product-option-item[data-option-position="' + position + '"][data-value]')).filter(function (node) {
      return normalizeOptionText(node.getAttribute('data-value')) === normalized;
    })[0];
    if (!option) return false;
    if (option.getAttribute('data-selected') !== 'true') option.click();
    return true;
  }

  function updateMainDropdown(form, position, value) {
    var normalized = normalizeOptionText(value);
    var changed = false;
    form.querySelectorAll('.sf-product-variant-option-dropdown').forEach(function (select) {
      var matchedIndex = -1;
      Array.prototype.slice.call(select.options || []).forEach(function (option, index) {
        if (normalizeOptionText(option.getAttribute('data-value') || option.textContent || option.value) === normalized) matchedIndex = index;
      });
      if (matchedIndex >= 0 && select.selectedIndex !== matchedIndex) {
        select.selectedIndex = matchedIndex;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
      }
    });
    var label = form.querySelector('[data-option-label][data-label-position="' + position + '"]');
    if (label) label.textContent = value;
    return changed;
  }

  function syncMainPickerFromVariant(productId, variant) {
    if (!productId || !variant || syncingSticky) return;
    syncingSticky = true;
    try {
      mainForms(productId).forEach(function (form) {
        setFormVariantId(form, variant);
        optionValuesFromVariant(variant).forEach(function (value, index) {
          var position = index + 1;
          clickMainOption(form, position, value) || updateMainDropdown(form, position, value);
        });
        setFormVariantId(form, variant);
        form.dispatchEvent(new CustomEvent('divetia:variant-sync', { bubbles: true, detail: { variant: variant } }));
      });
    } finally {
      window.setTimeout(function () { syncingSticky = false; }, 0);
    }
  }

  function syncStickyPickerFromVariant(productId, variant) {
    if (!productId || !variant || syncingSticky) return;
    stickyForms(productId).forEach(function (form) {
      setFormVariantId(form, variant);
      form.querySelectorAll(STICKY_VARIANT_SELECTOR).forEach(function (select) {
        if (toStringId(select.value) !== toStringId(variant.id)) select.value = variant.id;
      });
    });
  }

  function activeVariantId(block, variant) {
    if (variant && variant.id) return toStringId(variant.id);
    var form = findForm(block);
    var input = form ? form.querySelector(ID_INPUT_SELECTOR) : null;
    if (input && input.value) return toStringId(input.value);
    try {
      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (urlVariant) return urlVariant;
    } catch (error) {}
    var selected = block.getAttribute('data-selected-variant-id');
    if (selected) return toStringId(selected);
    return '';
  }

  function blocksForProduct(productId) {
    if (!productId) return Array.prototype.slice.call(document.querySelectorAll(BLOCK_SELECTOR));
    return Array.prototype.slice.call(document.querySelectorAll(BLOCK_SELECTOR + '[data-product-id="' + productId + '"]'));
  }

  function setText(block, selector, value) {
    var node = block.querySelector(selector);
    if (node) node.textContent = value || '';
  }

  function selectedOptionValues(block) {
    var form = findForm(block);
    var productId = block.getAttribute('data-product-id') || (form && form.getAttribute('data-product-id')) || '';
    var values = [];
    if (productId && pendingOptionValues[productId]) values.push(pendingOptionValues[productId]);
    if (!form) return values;
    form.querySelectorAll('.product-option-item[data-selected="true"], .product-option-item[data-value][aria-pressed="true"]').forEach(function (node) {
      values.push(node.getAttribute('data-value') || node.textContent);
    });
    form.querySelectorAll('.sf-product-variant-option-dropdown').forEach(function (select) {
      var option = select.options && select.options[select.selectedIndex];
      if (option) values.push(option.getAttribute('data-value') || option.textContent || option.value);
    });
    form.querySelectorAll('[data-option-label]').forEach(function (node) { values.push(node.textContent); });
    return values.map(normalizeOptionText).filter(Boolean);
  }

  function entryFromSelectedOption(block, map, currentEntry) {
    var selectedValues = selectedOptionValues(block);
    if (!selectedValues.length) return currentEntry;
    var keys = Object.keys(map || {});
    var selectedLookup = selectedValues.reduce(function (lookup, value) { lookup[value] = true; return lookup; }, {});
    if (currentEntry && selectedLookup[normalizeOptionText(currentEntry.option1)]) return currentEntry;
    for (var i = 0; i < keys.length; i += 1) {
      var raw = map[keys[i]];
      var option = normalizeOptionText(raw && (raw.option1 || raw.label || raw.title));
      if (option && selectedLookup[option]) return normalizeEntry(raw);
    }
    for (var j = 0; j < keys.length; j += 1) {
      var entry = map[keys[j]];
      var optionText = normalizeOptionText(entry && (entry.option1 || entry.label || entry.title));
      if (optionText && selectedValues.some(function (value) { return optionText.indexOf(value) !== -1 || value.indexOf(optionText) !== -1; })) return normalizeEntry(entry);
    }
    return currentEntry;
  }

  function updateTitle(block, entry) {
    var title = document.querySelector('[data-divetia-variant-title]');
    if (!title || !entry || !entry.heading) return;
    title.textContent = titleBase(block) + ' — ' + entry.heading;
  }

  function updateDescription(block, entry) {
    if (!entry || !entry.descriptionHtml) return;
    var productId = block.getAttribute('data-product-id');
    var selector = productId ? DESCRIPTION_SELECTOR + '[data-product-id="' + productId + '"]' : DESCRIPTION_SELECTOR;
    var descriptions = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!descriptions.length) descriptions = Array.prototype.slice.call(document.querySelectorAll(DESCRIPTION_SELECTOR));
    if (!descriptions.length) descriptions = Array.prototype.slice.call(document.querySelectorAll('.product__description.prose'));
    descriptions.forEach(function (description) {
      if (description.innerHTML !== entry.descriptionHtml) description.innerHTML = entry.descriptionHtml;
    });
  }

  function productTitleForAria(block, entry) {
    var title = document.querySelector('[data-divetia-variant-title]');
    var visibleTitle = title && title.textContent && title.textContent.trim();
    if (visibleTitle) return visibleTitle;
    if (entry && entry.heading) return titleBase(block) + ' — ' + entry.heading;
    return titleBase(block);
  }

  function updateQuantityAriaLabels(block, entry) {
    var productTitle = productTitleForAria(block, entry);
    if (!productTitle) return;
    var productId = block.getAttribute('data-product-id') || '';
    var forms = mainForms(productId).concat(stickyForms(productId));
    if (!forms.length) forms = Array.prototype.slice.call(document.querySelectorAll(FORM_SELECTOR));
    forms.forEach(function (form) {
      form.querySelectorAll('[aria-label]').forEach(function (node) {
        var label = node.getAttribute('aria-label') || '';
        var match = label.match(/^(Increase|Decrease) quantity(?: of .*)?$/i);
        if (!match) return;
        var verb = match[1].charAt(0).toUpperCase() + match[1].slice(1).toLowerCase();
        node.setAttribute('aria-label', verb + ' quantity of ' + productTitle);
      });
    });
  }

  function renderBlock(block, variant) {
    if (!block) return false;
    var map = findMap(block);
    var id = activeVariantId(block, variant);
    var entry = entryFromSelectedOption(block, map, normalizeEntry(map[id]));
    if (!entry) { block.hidden = true; return false; }
    if (entry.id) id = entry.id;
    var hiddenDataHook = block.getAttribute('data-divetia-stone-copy-hidden') === 'true';
    if (!hiddenDataHook) {
      setText(block, '[data-stone-heading]', entry.heading);
      setText(block, '[data-stone-body]', entry.copy);
      setText(block, '[data-stone-badge]', entry.badge ? ' - ' + entry.badge : '');
    }
    updateTitle(block, entry);
    updateDescription(block, entry);
    updateQuantityAriaLabels(block, entry);
    block.hidden = hiddenDataHook || !entry.copy;
    block.setAttribute('data-selected-variant-id', id);
    return true;
  }

  function renderProduct(productId, variant) { blocksForProduct(productId).forEach(function (block) { renderBlock(block, variant); }); }
  function renderAll(variant) { document.querySelectorAll(BLOCK_SELECTOR).forEach(function (block) { renderBlock(block, variant); }); }

  function scheduleRender(productId, variant) {
    var key = productId || 'all';
    var delays = [0, 50, 160, 350, 700];
    if (scheduledRender[key]) scheduledRender[key].forEach(window.clearTimeout);
    scheduledRender[key] = delays.map(function (delay) {
      return window.setTimeout(function () {
        if (delay === delays[delays.length - 1]) delete scheduledRender[key];
        productId ? renderProduct(productId, variant) : renderAll(variant);
      }, delay);
    });
  }

  function bindVariantBus(block) {
    var productId = block.getAttribute('data-product-id');
    var bus = window.MinimogEvents || window._ThemeEvent;
    if (!productId || !bus || typeof bus.subscribe !== 'function' || busSubscriptions[productId]) return;
    busSubscriptions[productId] = bus.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
      syncStickyPickerFromVariant(productId, variant);
      scheduleRender(productId, variant);
    });
  }

  function initBlock(block) {
    if (!block || block.getAttribute('data-divetia-stone-copy-ready') === 'true') return;
    block.setAttribute('data-divetia-stone-copy-ready', 'true');
    bindVariantBus(block);
    renderBlock(block);
  }

  function init() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach(initBlock);
    if (!observerStarted) {
      observerStarted = true;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches(BLOCK_SELECTOR)) initBlock(node);
            if (node.querySelectorAll) node.querySelectorAll(BLOCK_SELECTOR).forEach(initBlock);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  ['change', 'input', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var form = event.target && event.target.closest ? event.target.closest(FORM_SELECTOR) : null;
      var optionItem = event.target && event.target.closest ? event.target.closest('.product-option-item[data-value]') : null;
      var stickySelect = event.target && event.target.closest ? event.target.closest(STICKY_VARIANT_SELECTOR) : null;
      if (stickySelect && !(stickySelect.closest(STICKY_FORM_SELECTOR))) stickySelect = null;
      if (stickySelect && eventName === 'change') {
        var stickyForm = stickySelect.closest(FORM_SELECTOR);
        var stickyProductId = stickyForm && stickyForm.getAttribute('data-product-id') || '';
        var stickyVariant = variantById(stickyProductId, stickySelect.value);
        if (stickyVariant) {
          setFormVariantId(stickyForm, stickyVariant);
          pendingOptionValues[stickyProductId] = optionValuesFromVariant(stickyVariant)[0] || stickyVariant.title || '';
          syncMainPickerFromVariant(stickyProductId, stickyVariant);
          scheduleRender(stickyProductId, stickyVariant);
        }
        return;
      }
      if (form && optionItem) pendingOptionValues[form.getAttribute('data-product-id') || ''] = optionItem.getAttribute('data-value') || optionItem.textContent || '';
      if (form && !form.matches(STICKY_FORM_SELECTOR) && !form.closest('.prod__sticky-atc')) {
        var productId = form.getAttribute('data-product-id');
        scheduleRender(productId);
        window.setTimeout(function () {
          var block = blocksForProduct(productId)[0];
          var values = block ? selectedOptionValues(block) : [];
          var input = form.querySelector(ID_INPUT_SELECTOR);
          var variant = optionItem ? variantByOptions(productId, values) || variantById(productId, input && input.value) : variantById(productId, input && input.value) || variantByOptions(productId, values);
          if (variant) syncStickyPickerFromVariant(productId, variant);
        }, 120);
      }
    });
  });
  window.addEventListener('popstate', function () { scheduleRender(); });
  window.addEventListener('pageshow', function () { init(); scheduleRender(); });
  document.addEventListener('shopify:section:load', function () { init(); scheduleRender(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.DivetiaStoneCopy = { init: init, renderAll: renderAll, renderProduct: renderProduct };
})();
